import { Brand } from "@/components/brand";

/**
 * Splash UI rendered while React Router resolves initial loaders.
 *
 * Two windows of "white screen" exist on a hard refresh:
 *
 *   1. Browser fetching the JS bundle. Covered by the inline
 *      ``#kos-boot`` block in ``index.html`` — no React needed.
 *   2. Initial loader (``dashboardLoader`` → ``/me`` etc.) running
 *      before any route element mounts. Covered by this component
 *      via ``RouterProvider``'s ``fallbackElement``.
 *
 * Visual style matches the inline splash so the transition is
 * imperceptible: same brand mark, same animated progress bar, same
 * background tokens. The user only ever sees a single splash that
 * keeps animating until the dashboard mounts.
 */
export function BootSplash() {
  return (
    <output
      aria-label="Loading"
      className="fixed inset-0 flex flex-col items-center justify-center gap-4 bg-background text-muted-foreground"
    >
      <Brand href={null} compact />
      <div className="relative h-0.5 w-36 overflow-hidden rounded-full bg-muted">
        <div className="absolute h-full w-2/5 animate-top-progress bg-primary" />
      </div>
    </output>
  );
}
